const FIRM_DOCUMENT_PREVIEW_QUERY_SLUG_MAX_LENGTH = 80;
const FIRM_DOCUMENT_PREVIEW_QUERY_TRAILING_ID_PATTERN = /-(\d+)$/;
const FIRM_DOCUMENT_PREVIEW_QUERY_NUMERIC_ID_PATTERN = /^\d+$/;

interface FirmDocumentPreviewQueryValueOptions {
  documentReferenceId: number;
  fileName?: string | null;
}

const getFirmDocumentPreviewSlug = (fileName?: string | null) => (
  fileName
    ?.trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, FIRM_DOCUMENT_PREVIEW_QUERY_SLUG_MAX_LENGTH)
    .replace(/-+$/g, '') ?? ''
);

const getPositiveDocumentReferenceId = (documentReferenceId?: string | null) => {
  if (!documentReferenceId) {
    return null;
  }

  const numericDocumentReferenceId = Number(documentReferenceId);

  return Number.isInteger(numericDocumentReferenceId) && numericDocumentReferenceId > 0
    ? numericDocumentReferenceId
    : null;
};

export const getFirmDocumentPreviewQueryValue = ({
  documentReferenceId,
  fileName,
}: FirmDocumentPreviewQueryValueOptions) => {
  const fileNameSlug = getFirmDocumentPreviewSlug(fileName);

  return fileNameSlug ? `${fileNameSlug}-${documentReferenceId}` : String(documentReferenceId);
};

export const getFirmDocumentPreviewDocumentReferenceId = (queryValue: string | null) => {
  if (!queryValue) {
    return null;
  }

  if (FIRM_DOCUMENT_PREVIEW_QUERY_NUMERIC_ID_PATTERN.test(queryValue)) {
    return getPositiveDocumentReferenceId(queryValue);
  }

  const documentReferenceId = queryValue.match(FIRM_DOCUMENT_PREVIEW_QUERY_TRAILING_ID_PATTERN)?.[1];

  return getPositiveDocumentReferenceId(documentReferenceId);
};
